import { useIfpFormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { WizardMachineType } from '@sec-loans-ui/ifp-loans/wizard/wizardMachine'
import { ENDPOINT_IFP_GET_APPLICATION, SecLoansErrorCode } from '@shared/sec-loans'
import { GetDataStep } from '@ui-common/steps/GetDataStep'
import { callEndpoint } from '@ui-common/utils'
import { ErrorVisualMode } from '@ui-components/containers/ErrorComponentTypes'
import { useIntl } from 'react-intl'
import { ActorRefFrom } from 'xstate'

export const GetApplicationStep = ({
  parentService,
  onGoBack,
}: {
  parentService: ActorRefFrom<WizardMachineType>
  onGoBack: () => void
}) => {
  const { applicationId, exit } = useIfpFormContext()
  const { formatMessage } = useIntl()

  const getErrorProperties = (errorCode?: SecLoansErrorCode) => {
    if (errorCode === SecLoansErrorCode.OtherNonTechnical) {
      return {
        mode: ErrorVisualMode.TechnicalError,
        heading: formatMessage({ id: 'common-non-technical-error-heading' }),
        text: formatMessage({ id: 'common-non-technical-error-text' }),
        action: {
          label: formatMessage({ id: 'common-back' }),
          onClick: onGoBack,
        },
      }
    }
  }

  return (
    <GetDataStep
      parentService={parentService}
      getDataCallback={() => callEndpoint(ENDPOINT_IFP_GET_APPLICATION, { pathParams: { applicationId } })}
      onAbort={exit}
      heading={formatMessage({ id: 'common-loading-application-data' })}
      getErrorProperties={getErrorProperties}
    />
  )
}
